<template>
  <div v-if="user" class="py-8">
    <EmptyState
        v-if="!user?.roles?.length"
        @on-create="assignUserRole"
        :create-label="$t('pages.admin.users.users.user.roles.user_roles_view.assign_role')"
        :title="$t('pages.admin.users.users.user.roles.user_roles_view.no_roles_assigned')"
        :description="$t('pages.admin.users.users.user.roles.user_roles_view.get_started_by_adding_a_role_for_x', { name: user.name})"/>

    <template v-else>
      <Button :label="$t('pages.admin.users.users.user.roles.user_roles_view.assign_role')" @click="assignUserRole"/>

      <DataTable :value="rolesWithTeam" size="small" class="-mx-6 lg:-mx-8 mt-6">
        <Column field="display_name" :header="$t('pages.admin.users.users.user.roles.user_roles_view.role')"
                class="pl-6 lg:pl-8 whitespace-nowrap"/>
        <Column field="team.display_name" :header="$t('pages.admin.users.users.user.roles.user_roles_view.team')"
                class="w-full"/>
        <Column headerStyle="width: 5rem; text-align: center" bodyStyle="text-align: center; overflow: visible">
          <template #body="{data}">
            <Button type="button" label="Delete" severity="danger" text v-if="$auth.hasPermission('delete:role-users')"
                    @click="unassignUserRole(data)"/>
          </template>
        </Column>
      </DataTable>
    </template>
  </div>

  <AssignUserRoleSlideOver ref="assignUserRoleSlideOver" @role-assigned="$emit('refresh-user')"/>
</template>

<script>
import UserRolesForm from "@/Forms/User/UserRolesForm.vue";
import {mapStores} from "pinia";
import {useUsersStore} from "@/stores/users.js";
import AssignUserRoleSlideOver from "@/Slideovers/AssignUserRoleSlideOver.vue";
import {useForm} from "laravel-precognition-vue";
import EmptyState from "@/Components/EmptyState.vue";

export default {
  name: "UserRolesView",
  components: {EmptyState, AssignUserRoleSlideOver, UserRolesForm},
  computed: {
    ...mapStores(useUsersStore),
    user() {
      return this.$attrs.user;
    },
    rolesWithTeam() {
      return this.user.roles.map(role => ({
        ...role,
        team: this.getTeam(role),
      }))
    }
  },
  methods: {
    getTeam(role) {
      return this.user?.roles_teams?.find(rt => rt.id === role.pivot.team_id)
    },
    assignUserRole() {
      this.$refs.assignUserRoleSlideOver.assignUserRole(this.user);
    },
    unassignUserRole(item) {
      this.$confirm.require({
        group: 'delete',
        message: this.$t('pages.admin.users.users.user.roles.user_roles_view.are_you_sure_you_want_to_un_assign_this_role'),
        header: this.$t('pages.admin.users.users.user.roles.user_roles_view.un_assign_role'),
        accept: () => {
          this.unassignUserRoleConfirmed(item);
        },
        reject: () => {
          this.$toast.add({
            severity: 'info',
            summary: this.$t('common.cancelled'),
            detail: $t('pages.admin.users.users.user.roles.user_roles_view.role_was_not_un_assigned'),
            life: 3000
          });
        }
      });
    },
    async unassignUserRoleConfirmed(item) {
      const form = useForm('post', `/users/${item.pivot.user_id}/roles`, {
        _method: 'delete',
        role_id: item.pivot.role_id,
        team_id: item.pivot.team_id,
      });
      try {
        await form.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.users.users.user.roles.user_roles_view.role_was_un_assigned'),
          life: 3000
        });
        this.$emit('refresh-user')
      } catch (e) {
        console.log(e);
      }
    }
  },
}
</script>